export default "__VITE_ASSET__4cc87e2e__"